import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { allAppsQuery } from 'queries';
import { createNormalizedMap, handleFetchError } from 'action-utils';

export default new AsyncActionHandler({
  name: 'fetch_all_apps',
  stateProp: 'all',
  defaultState: {
    apps: {}
  },
  handler(type = 'APP') {
    return async () => {
      try {
        const { data } = await apollo.query({
          query: allAppsQuery,
          variables: { type }
        });
        return {
          entries: data.apps
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },
  reduce(state, { entries }) {
    return {
      [this.stateProp]: {
        entries: entries.map((app) => app.id)
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(entries, state.apps)
      }
    };
  }
});
